import { TemplateEngine } from "../../../../js/lib/TemplateEngine";
import { renderWithoutShadow } from "../../../../js/lib/components/ShadowUtils";
import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { TLCCookie } from "../../Managers/CookieManager";
import { ApplicationData } from "../ApplicationData";
import * as React from 'react';
import { LocationConfigurationProvider } from "@tlc/ls2pac/components/LocationConfiguration";
import { BranchLimitProvider } from "@tlc/ls2pac/components/BranchLimits";
import { SearchResultSidebar } from "@tlc/ls2pac/components/SearchResultSidebar";
import { WindowLocationProvider } from "@tlc/ls2pac/components/WindowLocation";

export class HeaderView {
  constructor(callback) {
    this.id = LS2PAC_CONSTANTS.Ids.Header.mainHeader;
    this.tmpl = "tmpl/mainHeader.html";
    this.init(callback);
  }
  init(callback) {
    var _this = this;

    // TODO why is this here, instead of in the Login code?
    TLCCookie.remove("SAVED_DESTINATION");

    var headerData = {
      // additionalLinks: ApplicationData.locationConfiguration.getAdditionalLinks(),
      target: ApplicationData.locationConfiguration.getAdditionalLinkBehavior(),
    };

    TemplateEngine.fetch(
      this.tmpl,
      LS2PAC_CONSTANTS.Ids.mainPage,
      headerData,
      function () {
        const searchResultFiltersContainer = document.getElementById("searchUtilities");
        renderWithoutShadow(
          <LocationConfigurationProvider>
          <BranchLimitProvider>
          <WindowLocationProvider>
            <SearchResultSidebar></SearchResultSidebar>
          </WindowLocationProvider>
          </BranchLimitProvider>
          </LocationConfigurationProvider>,
          searchResultFiltersContainer,
          ApplicationData.language
        );
        
        _this.setLibraryName();// for the <title> tag

        // TODO why?
        setTimeout(function () {
          TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onWindowResize);
        }, 350);

        if (callback) {
          callback();
        }
      }
    );

  }
  setLibraryName() {
    if (ApplicationData.locationConfiguration.getLibraryName() != "") {
      var currentTitle = document.title;
      document.title =
        ApplicationData.locationConfiguration.getLibraryName() +
        " - " +
        currentTitle;
    }
  }

}
